/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts" />

module Meevo.Plugins.MarketPricing {
    "use strict";

    interface IMemberBenefitTemplateDiscountItem {
        id: string;
        name: string;
        discount: number;
        oldDiscount: number;
        isPercent: boolean;
    }

    interface IMemberBenefitTemplateModel extends Model.DataMaintenance {
        id?: string
        memberBenefitTemplateId?: string;
        displayName?: string,
        name?: string,

        serviceDiscount?: number;
        productDiscount?: number;
        packageDiscount?: number;

        servicesDiscount?: number,
        productsDiscount?: number,
        packagesDiscount?: number,
        oldServicesDiscount?: number,
        oldProductsDiscount?: number,
        oldPackagesDiscount?: number,

        serviceListDiscounts?: Model.MemberBenefitTemplateDiscountItem[];
        productListDiscounts?: Model.MemberBenefitTemplateDiscountItem[];
        packageListDiscounts?: Model.MemberBenefitTemplateDiscountItem[];
        serviceDiscounts?: IMemberBenefitTemplateDiscountItem[],
        productDiscounts?: IMemberBenefitTemplateDiscountItem[],
        packageDiscounts?: IMemberBenefitTemplateDiscountItem[],
    }

    export class MemberBenefitTemplatesSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<IMemberBenefitTemplateModel> {
        public membership: Meevo.Model.Membership;
        public membershipBenefitTemplate: Meevo.Model.MemberBenefitTemplate;
        public memberBenefitTemplate: any;
        public memberBenefitTemplateId: string;
        public criteria:any;
        public filterBySelectedItem: number = 1;
        public filterBy: Array<object>;

        constructor(protected params: Meevo.Model.ISectionParamsMarketPrice) {

            super(params.sectionId,
                params.displayNameContentKey,
                params.template,
                params.isPrimarySection,
                params.handlesOwnCrud,
                params.baseEndpoint,
                params.sectionEndpoint,
                params.loggingService,
                params.dataService,
                params.identityService,
                params.noun,
                params.appSettings,
                params.sectionSecurityKey
            );
            this.criteria = {hasMemberBenefitTemplate: true, coSearchType: 0};
            this.filterBy = [
                {id: 1, displayName: "LABEL_MEMBERSHIPS"},
                {id: 2, displayName: "HERO_SUB_MEMBERSHIP_BENEFIT_TEMPLATES"}
            ];
        }

        /**
         * Base class override which defines what a DEFAULT model looks like.
         */
        createSectionModelInstance(postAdd: (data: any) => any): void { }

        public resetInactiveFilter() {
            switch (this.filterBySelectedItem) {
                case 1:
                    delete this.membershipBenefitTemplate;
                    break;
                case 2:
                    delete this.membership;
                    break;
            }
        }

        /**
         * When tab is activated
         * */
        public sectionModelRetrieved(): void {
            this.showMemberBenefitTemplate();
        }

        public showMemberBenefitTemplate(): void {
            if (this.membership) {
                let membershipId = new Guid(this.membership.id);

                this.params.busyService.start();

                this.params.dataService.getItem('membership', membershipId).then((result: any) => {
                    this.memberBenefitTemplateId = result.membershipMemberSettings[0].membershipBenefitTemplateId;

                    this.params.dataService.getItem('memberBenefitTemplate', new Guid(this.memberBenefitTemplateId), this.parentItemId.toString()).then((result: any) => {
                        this.model = result;
                        this.takeBackup();

                        this.params.busyService.stop();
                    });
                });
            }
            if (this.membershipBenefitTemplate) {
                this.memberBenefitTemplateId = this.membershipBenefitTemplate.id;
                this.params.busyService.start();
                this.params.dataService.getItem('memberBenefitTemplate', new Guid(this.memberBenefitTemplateId), this.parentItemId.toString()).then((result: any) => {
                    this.model = result;
                    this.takeBackup();

                    this.params.busyService.stop();
                });
            }
        }

        public prevUnselected(): void {
            this.sectionEndpoint = '';

            super.prevUnselected();
        }

        /**
         * Save
         * */
        public preSave(): any {
            this.sectionEndpoint = 'memberBenefit';

            let originalEntity = this.originalEntity,
                templateModel: IMemberBenefitTemplateModel = {
                    id: this.parentItemId.toString(),
                    name: originalEntity.displayName,
                    memberBenefitTemplateId: this.memberBenefitTemplateId,
                    oldServicesDiscount: originalEntity.serviceDiscount === this.model.serviceDiscount ? null : originalEntity.serviceDiscount,
                    oldProductsDiscount: originalEntity.productDiscount === this.model.productDiscount ? null : originalEntity.productDiscount,
                    oldPackagesDiscount: originalEntity.packageDiscount === this.model.packageDiscount ? null : originalEntity.packageDiscount,
                    servicesDiscount: this.model.serviceDiscount,
                    productsDiscount: this.model.productDiscount,
                    packagesDiscount: this.model.packageDiscount,
                };

            templateModel.serviceDiscounts = (this.model.serviceListDiscounts || []).map((elem: Model.MemberBenefitTemplateDiscountItem, index: number) => {
                return {
                    id: elem.id,
                    name: elem.displayName,
                    discount: elem.discountAmount,
                    oldDiscount: originalEntity.serviceListDiscounts[index].discountAmount === elem.discountAmount ? null : originalEntity.serviceListDiscounts[index].discountAmount,
                    isPercent: elem.isPercent
                };
            });

            templateModel.productDiscounts = (this.model.productListDiscounts || []).map((elem: Model.MemberBenefitTemplateDiscountItem, index: number) => {
                return {
                    id: elem.id,
                    name: elem.displayName,
                    discount: elem.discountAmount,
                    oldDiscount: originalEntity.productListDiscounts[index].discountAmount === elem.discountAmount ? null : originalEntity.productListDiscounts[index].discountAmount,
                    isPercent: elem.isPercent
                };
            });

            templateModel.packageDiscounts = (this.model.packageListDiscounts || []).map((elem: Model.MemberBenefitTemplateDiscountItem, index: number) => {
                return {
                    id: elem.id,
                    name: elem.displayName,
                    discount: elem.discountAmount,
                    oldDiscount: originalEntity.packageListDiscounts[index].discountAmount === elem.discountAmount ? null : originalEntity.packageListDiscounts[index].discountAmount,
                    isPercent: elem.isPercent
                };
            });

            this.model = templateModel;
        }
    }
}
